{
  "name": "@bt/parts-core",
  "version": "0.1.0",
  "private": true,
  "description": "What the app and the catalogue collector must agree on: part numbers, chassis codes, main groups, units, money and the parts catalogue's snapshot format. No dependencies, no I/O.",
  "type": "module",
  "exports": {
    ".": "./src/index.ts"
  },
  "scripts": {
    "typecheck": "tsc -p tsconfig.json"
  }
}
